import { Check } from "lucide-react";

export default function FeatureList({ overline, title, intro, items, testId }) {
  return (
    <section className="section-pad" data-testid={testId || "feature-list"}>
      <div className="container-sp grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          {overline && <div className="overline">{overline}</div>}
          <h2 className="font-serif text-3xl sm:text-4xl text-[#0D1B2A] mt-3 leading-tight">
            {title}
          </h2>
          {intro && <p className="text-[#4A5568] mt-5 leading-relaxed">{intro}</p>}
        </div>
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {items.map((it, i) => (
            <div key={i} className="card-sp" data-testid={`feature-item-${i}`}>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-full bg-[#EBE9E1] flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-[#D7141A]" />
                </div>
                <div>
                  <h3 className="font-serif text-lg text-[#0D1B2A] leading-snug">{it.title}</h3>
                  {it.body && <p className="text-sm text-[#4A5568] mt-2 leading-relaxed">{it.body}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
